
export const COMMISSION_KIND = ['merchant', 'gateway', 'agent'];

